export default __webpack_public_path__ + "static/media/slide6.6bd0feb2.webp";